import { Team } from '@yandex-int/k-common';
import { showIntlMessageNotification, showNetworkError } from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/src/components/constants';
import { all, put, select, takeLatest } from 'redux-saga/effects';

import { COMMON_NOTIFICATION_DELAY } from 'common.components/constants';
// @ts-ignore
import { cancelAddingNewStudent } from 'common.components/students/actions';
import { teamBuilderActions } from 'common.components/team-builder/actions';
import { getCurrentClass } from 'common.components/user/selectors';

import {
    handleRedirectToCreatedClass,
    setShouldRedirect,
    finishClassCreation,
    startAddingNewStudentsList,
} from './actions';
import { FINISH_CLASS_CREATION, HANDLE_REDIRECT_TO_CREATED_CLASS, START_ADDING_NEW_STUDENTS_LIST } from './constants';

export function* classSagasWatcher() {
    yield all([
        finishClassCreationWatcher(),
        startAddingNewStudentsListWatcher(),
        handleRedirectToCreatedClassWatcher(),
    ]);
}

function* finishClassCreationWatcher() {
    yield takeLatest(FINISH_CLASS_CREATION, finishTeamCreationSaga);
}

function* startAddingNewStudentsListWatcher() {
    yield takeLatest(START_ADDING_NEW_STUDENTS_LIST, startAddingNewStudentsListSaga);
}

function* handleRedirectToCreatedClassWatcher() {
    yield takeLatest(HANDLE_REDIRECT_TO_CREATED_CLASS, handleRedirectToCreatedClassSaga);
}

function* finishTeamCreationSaga(action: ReturnType<typeof finishClassCreation>) {
    try {
        yield put(setShouldRedirect(true, action.createdTeamId));
    } catch (error) {
        yield put(showNetworkError(error));
    }
}

function* startAddingNewStudentsListSaga(action: ReturnType<typeof startAddingNewStudentsList>) {
    try {
        const { entryPoint } = action;

        yield put(cancelAddingNewStudent());

        yield put(
            teamBuilderActions.start({
                entryPoint: entryPoint,
            })
        );
    } catch (error) {
        yield put(showNetworkError(error));
    }
}

function* handleRedirectToCreatedClassSaga(action: ReturnType<typeof handleRedirectToCreatedClass>) {
    try {
        const { classId } = action;
        const currentClass: Team | null = yield select(getCurrentClass, { classId });
        const { is_supervisor: isSupervisor, level, name } = currentClass!;

        if (!isSupervisor) {
            yield put(
                showIntlMessageNotification({
                    closeDelay: COMMON_NOTIFICATION_DELAY,
                    gravity: GRAVITIES.BOTTOM,
                    messageId: 'toast.class.accessObtained',
                    messageValues: { name, level },
                    withExplicitClose: true,
                    theme: NOTIFICATION_THEMES.TOAST,
                })
            );
        }
    } catch (error) {
        console.error(error);
    }
}
